// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error404_wrapper__1uZau","inactive":"error404_inactive__1hmds"};